import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function CustomAppsDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/5bcc1c4843d900105675dd139ef946f0800d9fbf-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Custom Apps Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>From web apps to mobile apps, we specialize in purpose-built custom apps for all kinds of businesses across all industries!</p>
            <h3>Looking for Custom Application Development in India?</h3>
            <p style={{ marginBottom: '3.5rem' }}>YGS Web Solutions develops custom applications that are tailored to fit your business requirements. We seek to understand the objectives your application is intended to accomplish and then we leverage our strategy and technical development expertise to create an application that will support your business goals.</p>
            <p style={{ marginBottom: '3.5rem' }}>Our client-focused team employs the right tools to provide reliable and cost-effective business and web applications that will improve engagement and productivity and generate more revenue. An app is nothing if not for its functionality. As every business is different, features are customized based on each project's unique requirements. With the right tools and unparalleled design, our apps provide you with an intuitive interface and can also automate several business processes, resulting in improved business returns.</p>
            <h3>Custom Apps Done the Right Way</h3>
            <p style={{ marginBottom: '3.5rem' }}>We specialize in designing, developing, deploying, and optimizing web-based and desktop-based business applications that are customized and highly functional. These custom apps include:</p>
            <h3>Desktop software for business</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Custom applications for client servers</li>
              <li>Various utilities for software</li>
              <li>Graphic processing applications </li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>If you are looking to build a custom app, contact us for a consultation.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/e48efe0cab72928cc4e3b3ba67396fac5d105a76-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default CustomAppsDevelopment